<template>
  <!-- <transition name="custom-modal"> -->
  <div v-if="show" class="custom-modal">
    <q-layout view="Lhh lpR fff" container class="bg-custom custom-layout">
      <q-header class="bg-custom">
        <ToolBar>
          <q-btn round :color="q.dark.isActive ? 'purple-3' : 'purple-9'" flat icon="close" @click="$emit('cancel')">
            <q-tooltip>Cancelar</q-tooltip>
          </q-btn>
        </ToolBar>
      </q-header>

      <q-page-container style="max-width: 460px; margin: 0 auto">
        <q-page padding class="q-pt-lg">
          <div :class="`text-h5 ${description ? 'q-mb-xs' : 'q-mb-lg'}`">
            {{ message }}
          </div>
          <pre v-if="description" class="text-grey-8 q-mb-lg" style="white-space: pre-wrap;">{{ description }}</pre>

          <!-- <q-btn flat class="full-width bg-purple-9 q-py-sm q-my-md" color="white" @click="$emit('confirm')">{{ confirm ||
            'Continuar' }}</q-btn>
          <q-btn flat :color="q.dark.isActive ? 'purple-2' : 'purple-9'" :class="`${q.dark.isActive ? 'bg-dark' : 'bg-purple-1'
            } q-py-sm full-width`" @click="$emit('cancel')">Cancelar</q-btn> -->

          <div class="flex" style="gap: .5rem;">
            <q-btn flat :color="q.dark.isActive ? 'purple-2' : 'purple-9'"
              :class="`${q.dark.isActive ? 'bg-dark' : 'bg-purple-1'} q-py-sm`" @click="$emit('cancel')">
              {{ cancelLabel }}
            </q-btn>
            <div style="flex-grow: 1;">
              <q-btn color="purple-9 q-py-sm full-width" unelevated :disable="submitting" :loading="submitting"
                @click="$emit('confirm')">
                {{ confirm || confirmLabel }}
              </q-btn>
            </div>
          </div>
        </q-page>
      </q-page-container>
    </q-layout>
  </div>
  <!-- </transition> -->
</template>

<script lang="ts" setup>
import { useQuasar } from 'quasar';
import ToolBar from './ToolBar.vue';

defineEmits(['confirm', 'cancel']);
defineProps({
  show: Boolean,
  submitting: {
    type: Boolean,
    default: false,
  },
  message: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    default: '',
  },
  confirm: {
    type: String,
    default: '',
  },
  cancelLabel: {
    type: String,
    default: 'Cancelar',
  },
  confirmLabel: {
    type: String,
    default: 'Continuar',
  },
});

const q = useQuasar();
</script>

<style scoped>
/* .custom-layout {
  box-shadow: 0 0 44px #ccc;
} */
.custom-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  /* transition: transform 0.6s ease-in-out;
  transform: translateY(0); */
}

.bg-custom {
  color: #000;
  background-color: #fff;
}

.body--dark .bg-custom {
  color: #fff;
  background-color: #121212;
}

/* .custom-modal-enter-from, .custom-modal-leave-to {
  transform: translateY(100vh);
} */

pre {
  font-family: "Roboto", "-apple-system", "Helvetica Neue", Helvetica, Arial, sans-serif;
  max-width: 100%;
  white-space: pre;
}
</style>
